import { Table } from "@similarweb/pro-logic-components";

import { useTranslation } from "pro-features/components/WithTranslation";

import { useCompactData } from "../../../hooks/useCompactData";
import type { TrafficSource } from "../../../traffic-sources-tabs";
import { useShareOfChannelTrafficData } from "../../useShareOfChannelTrafficData";

import { type Data, useColumnsConfig } from "./useColumnConfig";

interface IShareOfChannelTrafficTable {
    trafficSource: TrafficSource;
}

export const ShareOfChannelTrafficTable = ({ trafficSource }: IShareOfChannelTrafficTable) => {
    const translate = useTranslation();
    const { data, isLoading } = useShareOfChannelTrafficData(trafficSource);
    const compactData = useCompactData({ data, isOthersShareCalculated: true });
    const columnsConfig = useColumnsConfig();

    return (
        <Table<Data>
            data={compactData}
            columnConfig={columnsConfig}
            isLoading={isLoading}
            noData={{
                title: translate("global.nodata.notavilable"),
            }}
            tableLayout="auto"
            highlightedRowSelector={(record) => !Array.isArray(record.domain) && !!record.domain.isPrimaryDomain}
        />
    );
};
